import { Outlet } from 'react-router-dom'
import { ToastContainer } from 'react-toastify'

import Menu from './Menu/Menu'

import styles from './layout.module.scss'

function Layout() {
    return (
        <div className={styles.app}>
            <Menu />
            <Outlet />
            <ToastContainer
                position="bottom-right"
                pauseOnHover={false}
                theme="dark"
                toastClassName={styles.app__toasts}
            />
        </div>
    )
}

export default Layout
